import Color from "color";
import randomcolor from "randomcolor";
import type { ReactNode } from "react";
import { SemiBoldText } from "src/components/v1";
import { cn } from "src/utilities/shadcnUtils";

export enum Variant {
  BASE = "base",
  GREEN = "green",
  RED = "red",
  YELLOW = "yellow",
}

const SIZE_CLASS: Record<"sm" | "md", string> = {
  sm: "py-px px-3",
  md: "py-[5px] px-4",
};

const SIZE_TEXT_CLASS: Record<"sm" | "md", string> = {
  sm: "whitespace-nowrap text-[10px]",
  md: "whitespace-nowrap text-[10px]",
};

const variantClass: Record<Variant | "base", string> = {
  base: "bg-muted text-foreground/80",
  green: "bg-green-200 text-green-800 dark:bg-green-900 dark:text-green-100",
  red: "bg-red-200 text-red-800 dark:bg-red-900 dark:text-red-100",
  yellow: "bg-yellow-200 text-yellow-800 dark:bg-yellow-700 dark:text-yellow-100",
};

const Chip = ({
  children,
  variant,
  className,
  value,
  size = "md",
}: {
  children: ReactNode;
  variant?: Variant | `${Variant}`;
  className?: string;
  value?: string;
  size?: "sm" | "md";
}) => {
  const backgroundColor =
    !variant && typeof children === "string"
      ? randomcolor({
          seed: children,
          luminosity: "dark",
        })
      : undefined;

  return (
    <div
      className={cn(
        "h-fit rounded-full inline-flex justify-center",
        SIZE_CLASS[size],
        !backgroundColor && variantClass[variant || Variant.BASE],
        className
      )}
      style={backgroundColor ? { backgroundColor, color: "white" } : undefined}
    >
      <SemiBoldText
        inline
        value={value}
        className={SIZE_TEXT_CLASS[size]}
        style={
          backgroundColor
            ? Color(backgroundColor).isDark()
              ? { color: "white" }
              : { color: "black" }
            : undefined
        }
      >
        {children}
      </SemiBoldText>
    </div>
  );
};

export default Chip;
